import * as React from 'react'

import * as styles from './imagePlaceholder.module.css'

interface IProps {
  ratio?: number
  children: any
}

const ImagePlaceholder = ({ ratio = 1, children }: IProps) => (
  <div className={styles.root} style={{ paddingTop: `${ratio * 100}%` }}>
    {children}
  </div>
)

export default ImagePlaceholder
